<div class="canvas-content">
    <router-outlet></router-outlet>
    <canvas-spinner></canvas-spinner>
</div>
@if (!isEmbedded() && !isLoading()) {
    <footer class="canvas-footer">
        <div class="footer-content">
            <img src="images/jobseq-logo.svg" width="104" height="18" alt="JobsEQ logo" />
            <div class="footer-copy">
                <p class="footer-title">This report was created with JobsEQ Canvas</p>
                <p class="footer-detail">Canvas brings analysis, visualization, collaboration, and reporting into one workspace inside JobsEQ</p>
            </div>
            <a
                (click)="onFooterLinkClick('learn_more')"
                class="learn-more-link"
                href="https://www.chmura.com/jobseq/canvas?utm_source=canvas&utm_medium=published-canvas&utm_campaign=canvas-footer"
                target="_blank"
                rel="noopener noreferrer">
                Learn More
            </a>
        </div>
    </footer>
}
